import React from 'react';

import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

export const ImageViewer = ({ children }) => {
  return (
    <TransformWrapper
      initialScale={1}
      disablePadding
      minScale={0.5}
      centerZoomedOut
      centerOnInit
      minPositionX={0}
      minPositionY={0}
    >
      {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
        <React.Fragment>
          <div className="tools">
            <button onClick={() => zoomIn()}>Zoom In (+)</button>
            <button onClick={() => zoomOut()}>Zoom Out (-)</button>
            <button onClick={() => resetTransform()}>Reset Zoom</button>
          </div>
          <TransformComponent
            wrapperStyle={{ width: 'inherit' }}
            contentStyle={{ width: 'inherit' }}
          >
            {children}
          </TransformComponent>
        </React.Fragment>
      )}
    </TransformWrapper>
  );
};
